// When the brand splash plays and how long it stays. The native apps play it on every launch of the feed, 1.5×
// faster and never held past its animation; the browser keeps its once-per-session splash with a minimum display.
const SESSION_SHOWN_KEY = "splashShown"
const NATIVE_TIME_SCALE = 1.5
// Native: a beat for the last flourish to land before the exit starts (the browser already holds a minimum display).
const NATIVE_EXIT_HOLD_MS = 160

function read(storage, key) {
  try { return storage?.getItem(key) ?? null } catch { return null }
}

export function splashMode({ native, mainPage, session = globalThis.sessionStorage }) {
  if (native && !mainPage) return "skip"
  if (read(session, SESSION_SHOWN_KEY) === "true") return "skip"
  return "play"
}

export function splashTimeScale({ native }) {
  return native ? NATIVE_TIME_SCALE : 1
}

export function splashHoldMs({ native, minDurationMs, elapsedMs }) {
  return native ? 0 : Math.max(0, minDurationMs - elapsedMs)
}

export function splashFadeMs({ native, fadeMs, nativeFadeMs }) {
  return native ? nativeFadeMs : fadeMs
}

export function markSplashShown(session = globalThis.sessionStorage) {
  try { session?.setItem(SESSION_SHOWN_KEY, "true") } catch { /* private mode */ }
}

export function splashExitHoldMs({ native, reduced = false }) {
  return native && !reduced ? NATIVE_EXIT_HOLD_MS : 0
}

// The exit is choreographed, not one uniform fade (which double-exposed the logo over the page): the mark (frame,
// logo, icons) lifts and fades first, the backdrop follows a beat later, and the whole takes totalMs.
export function splashExitTiming(totalMs) {
  return {
    markMs: Math.round(totalMs * 0.5),
    backdropDelayMs: Math.round(totalMs * 0.3),
    backdropMs: Math.round(totalMs * 0.7)
  }
}
